import axios from "axios";

const endpointUrl = () => {
  const projectId = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG).projectId;
  if (process.env.NODE_ENV === "production") {
    return `https://europe-west1-${projectId}.cloudfunctions.net/generatePdf`;
  } else {
    return `http://localhost:5000/${projectId}/europe-west1/generatePdf`;
  }
};

const requestPdfReport = (Data, Template) => {
  return () => {
    console.log("requestPdfReport: Action");
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        // url: "/api/v1/generatePdf",
        url: endpointUrl(),
        responseType: "blob",
        data: { Data, Template }
      })
        .then(response => {
          if (
            response.status === 200 &&
            response.headers["content-type"] === "application/pdf"
          ) {
            resolve(response.data);
          } else {
            reject({ Error: "Download failed", response });
          }
        })
        .catch(reject);
    });
  };
};

export default requestPdfReport;
